import { createContext } from 'react';
import type { useMcpChatOnboardingGate } from './useMcpChatOnboardingGate';

type McpChatOnboardingGate = ReturnType<typeof useMcpChatOnboardingGate>;

export type McpChatOnboardingContextValue = {
  gate: McpChatOnboardingGate;
  needsOnboarding: boolean;
  modalOpen: boolean;
  requestOnboarding: () => void;
  dismissOnboarding: () => void;
  /** Returns false when chat must stay blocked (modal opened). */
  assertChatAllowed: () => boolean;
};

export const McpChatOnboardingContext =
  createContext<McpChatOnboardingContextValue | null>(null);
